import React from 'react';

function Mission() {
    return (
        <div className="container text-center">
            <h1>Mission</h1>
        </div>
    )
}

export default Mission;
